import React from "react";
import { size, COLORS } from "../../utils";
import { Grid, Typography, CardMedia, Button, useMediaQuery, useTheme } from "@mui/material";

export default function Intro(props) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // mobile: <600px

    return (
        <Grid
            item
            container
            flexDirection={isMobile ? 'column-reverse' : 'row'}
            flexWrap="nowrap"
            alignItems="center"
            justifyContent="center"
            width={size({ p: 100 })}
            height={isMobile ? 'auto' : size({ p: 90, h: true })}
            columnGap={size({ p: 1 })}
            rowGap={isMobile ? size({ p: 4, h: true }) : 0}
            px={isMobile ? size({ p: 2 }) : 0}
        >
            {/* Text Section */}
            <Grid
                item
                container
                flexDirection="column"
                width={isMobile ? '100%' : size({ p: 30 })}
                height={isMobile ? 'auto' : size({ p: 50, h: true })}
                justifyContent="center"
                marginBottom={isMobile ? 0 : size({ p: 25, h: true })}
                textAlign={isMobile ? "center":""}
                mt={isMobile?'-25px':''}
            >
                <Grid item>
                    <Typography
                        component="span"
                        sx={{
                            fontFamily: 'Archia',
                            fontSize: isMobile ? size({ p: 2.5 }) : size({ p: 1.4 }),
                            fontWeight: 400,
                            textAlign: 'left',
                            color: COLORS.C2,
                        }}
                    >
                        Career At Genesys
                    </Typography>
                </Grid>
                <Grid item>
                    <Typography
                        component="span"
                        sx={{
                            fontFamily: 'Space Mono',
                            fontSize: isMobile ? size({ p: 5.5 }) : size({ p: 3 }),
                            fontWeight: 700,
                            textAlign: 'left',
                            textTransform: 'uppercase',
                            color: COLORS.C2,
                        }}
                    >
                        Work with us
                    </Typography>
                </Grid>
                <Grid item>
                    <Typography
                        sx={{
                            fontFamily: 'Space Mono',
                            fontSize: isMobile ? size({ p: 2.5 }) : size({ p: 1 }),
                            fontWeight: 400,
                            textAlign: isMobile?'center':'left',
                            color: COLORS.BLACK + 'A0',
                            px:isMobile?'1.5rem':'',
                            mt:isMobile?'0.4rem':''
                        }}
                    >
                        Join our dynamic team, where your expertise is valued, your ideas matter, and together we shape the future of technology.
                    </Typography>
                </Grid>
                <Grid item>
                    <Button
                        variant="contained"
                        onClick={() => {
                            document.getElementById('career_ops').scrollIntoView({
                                behavior: 'smooth', block: 'center'
                            });
                        }}
                        sx={{
                            backgroundColor: COLORS.C2,
                            fontFamily: 'Archia',
                            fontWeight: 500,
                            fontSize: isMobile ? size({ p: 2 }) : size({ p: 1 }),
                            ':hover': {
                                backgroundColor: COLORS.C2,
                            },
                            textTransform: 'none',
                            marginTop: isMobile?size({ p: 1, h: true }):size({ p: 4, h: true }),
                            alignSelf: 'flex-start',
                        }}
                    >
                        View Careers
                    </Button>
                </Grid>
            </Grid>

            {/* Image Section */}
            <Grid item height={isMobile ? '10rem' : size({ p: 90, h: true })} style={{marginTop:isMobile?'3rem':''}}>
                <CardMedia
                    component="img"
                    image="/assets/images/careers/careers.svg"
                    sx={{
                        width: isMobile ? '100%' : size({ p: 45 }),
                        height: isMobile ? 'auto' : size({ p: 45 }),
                        objectFit: 'contain',
                        maxWidth: size({ p: 50 }),
                        margin: '0 auto',
                    }}
                />
            </Grid>
        </Grid>
    );
}
